var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.56931 11.9999C4.15389 11.9999 3.44619 11.9999 2.94233 11.6978C2.61302 11.5003 2.34772 11.218 2.1765 10.8827C1.91453 10.3697 1.98495 9.69145 2.12579 8.33492C2.24335 7.20252 2.30214 6.63628 2.59123 6.22046C2.78102 5.94744 3.03773 5.72368 3.33865 5.56894C3.79699 5.33325 4.38776 5.33325 5.56931 5.33325H11.764C12.9456 5.33325 13.5363 5.33325 13.9947 5.56894C14.2956 5.72368 14.5523 5.94744 14.7421 6.22046C15.0312 6.63628 15.09 7.20252 15.2075 8.33492C15.3484 9.69145 15.4188 10.3697 15.1568 10.8827C14.9856 11.218 14.7203 11.5003 14.391 11.6978C13.8871 11.9999 13.1795 11.9999 11.764 11.9999",
    stroke: "#172B4D",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 5.33325V3.99992C12.0002 2.74284 12.0002 2.1143 11.6096 1.72378C11.2191 1.33325 10.5906 1.33325 9.3335 1.33325H8.00016C6.74308 1.33325 6.11454 1.33325 5.72402 1.72378C5.3335 2.1143 5.3335 2.74284 5.3335 3.99992V5.33325",
    stroke: "#172B4D",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99263 10.6667H7.34103C6.88418 10.6667 6.65574 10.6667 6.46138 10.7393C6.20224 10.8361 5.98034 11.0241 5.83096 11.2733C5.71893 11.4603 5.66353 11.7008 5.55272 12.1817C5.37958 12.9331 5.29302 13.3087 5.35189 13.61C5.4304 14.0117 5.67508 14.3517 6.01518 14.5317C6.27025 14.6667 6.62718 14.6667 7.34103 14.6667H9.99263C10.7065 14.6667 11.0634 14.6667 11.3185 14.5317C11.6586 14.3517 11.9033 14.0117 11.9818 13.61C12.0406 13.3087 11.9541 12.9331 11.781 12.1817C11.6702 11.7008 11.6147 11.4603 11.5027 11.2733C11.3533 11.0241 11.1314 10.8361 10.8723 10.7393C10.6779 10.6667 10.4495 10.6667 9.99263 10.6667Z",
    stroke: "#172B4D",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.667 8H12.673",
    stroke: "#172B4D",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.a254e7d38e7e85de30b1711c46ba15e7.svg";
export { ForwardRef as ReactComponent };